import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import {UserGroupsModule} from './users-groups/users-groups.module'
import {UsersModule} from './users/users.module'
import {UsersManagementComponent} from './usersManagement-ang7'

@NgModule({
    imports: [SharedModule,UserGroupsModule,UsersModule],
    declarations: [
        UsersManagementComponent
    ],
    entryComponents: [UsersManagementComponent],
    exports: [UsersManagementComponent]
})
export class UserManagementModule {}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/usersManagement/usersManagement-module.ts